module.exports = __webpack_public_path__ + "static/media/telfort-bw.a35baba1.jpg";